import React, { useEffect } from "react";
import { createPortal } from "react-dom";

interface BackdropProps {
  onClose: () => void;
}

const Backdrop: React.FC<BackdropProps> = ({ onClose }) => {
  // create a backdrop element to be used as a portal
  useEffect(() => {
    // hide overflow on body when backdrop is open
    document.body.style.overflow = "hidden";
    return () => {
      // reset overflow on body when backdrop is closed
      document.body.style.overflow = "unset";
    };
  }, []);

  return createPortal(
    <div
      onClick={onClose}
      className="fixed inset-0 overflow-y-auto z-[60] bg-black bg-opacity-60"></div>,
    document.getElementById("backdrop") as HTMLElement
  );
};

export default Backdrop;
